import { CoursewareProgress } from '../../../models/courseware/courseware-progress.model';

export enum ActionTypes {
  RememberCourseWareProgressions = '[RememberCourseWareProgressions] action',
  ResetCourseWareProgressions = '[ResetCourseWareProgressions] action'
}

export class RememberCourseWareProgressions {
  public static readonly type = ActionTypes.RememberCourseWareProgressions;
  constructor(
    public payload: CoursewareProgress[],
    public isLoadedSuccessfully: boolean
  ) { }
}

export class ResetCourseWareProgressions {
  public static readonly type = ActionTypes.ResetCourseWareProgressions;
  constructor() { }
}
